"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _analytics = _interopRequireDefault(require("./analytics"));
var DESTINATION_PAGE_NAME = 'premier inn: seo: hotels in';
var updateDestinationPageAnalytics = _ref => {
  var _thingsToDo$items$map, _thingsToDo$items;
  var {
    locationName,
    hotelDisplayedCount,
    destinations,
    hotels,
    filterType,
    thingsToDo,
    mapReference,
    premierPlusLabel
  } = _ref;
  var hotelsAnalytics = hotels.map((hotel, i) => {
    var _hotel$hotelFacilitie, _hotel$messagingFlag, _hotel$tripAdvisorRev, _hotel$tripAdvisorRev2;
    var hotelLabels = [];
    if ((_hotel$hotelFacilitie = hotel.hotelFacilities) !== null && _hotel$hotelFacilitie !== void 0 && _hotel$hotelFacilitie.find(facility => facility.code === 'PRR')) {
      hotelLabels.push(premierPlusLabel);
    }
    if ((_hotel$messagingFlag = hotel.messagingFlag) !== null && _hotel$messagingFlag !== void 0 && _hotel$messagingFlag.text && hotel.messagingFlag.text != 'hub') {
      hotelLabels.push(hotel.messagingFlag.text);
    }
    return {
      hotelName: hotel.name,
      hotelCode: hotel.hotelId,
      orderPosition: i + 1,
      hotelLabels,
      tripAdvisorRating: (_hotel$tripAdvisorRev = hotel.tripAdvisorReviews) === null || _hotel$tripAdvisorRev === void 0 ? void 0 : _hotel$tripAdvisorRev.rating,
      tripAdvisorReviewsCount: (_hotel$tripAdvisorRev2 = hotel.tripAdvisorReviews) === null || _hotel$tripAdvisorRev2 === void 0 ? void 0 : _hotel$tripAdvisorRev2.numberOfReviews
    };
  });
  var destinationsListAnalytics = destinations === null || destinations === void 0 ? void 0 : destinations.map((destination, i) => ({
    destinationLocationName: destination.title,
    destinationPosition: i + 1
  }));
  var analyticsThingsToDo = (_thingsToDo$items$map = thingsToDo === null || thingsToDo === void 0 || (_thingsToDo$items = thingsToDo.items) === null || _thingsToDo$items === void 0 ? void 0 : _thingsToDo$items.map(toDo => ({
    tileName: toDo.title,
    tilePosition: toDo.order
  }))) !== null && _thingsToDo$items$map !== void 0 ? _thingsToDo$items$map : [];
  var dlpAnalytics = {
    locationName,
    hotelDisplayedCount,
    destinations: destinationsListAnalytics,
    hotels: hotelsAnalytics,
    filterType,
    thingsToDo: analyticsThingsToDo,
    mapReference
  };
  return _analytics.default.update({
    pageName: "".concat(DESTINATION_PAGE_NAME, " ").concat(locationName),
    dlp: dlpAnalytics
  });
};
var _default = exports.default = updateDestinationPageAnalytics;